import type { Ref } from 'vue';
import { computed, unref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { getApi } from './api';
import type { PlaceSuggestion } from './getAccountPlaceSuggestions';

export default function getAccountPlaceSuggestion(
  accountId: Ref<number | null | undefined> | number | null | undefined,
  suggestionId: Ref<string | null | undefined> | string | null | undefined,
) {
  const query = useQuery({
    queryKey: [
      'place-suggestion',
      () => unref(accountId),
      () => unref(suggestionId),
    ],
    queryFn: async () => {
      const aid = unref(accountId);
      const sid = unref(suggestionId);
      if (aid == null || aid === 0 || !sid) {
        return null as PlaceSuggestion | null;
      }
      const { api, baseURL } = getApi();
      const res = await api.get(
        `api/v2/accounts/${aid}/place-suggestions/${sid}`,
        { baseURL, useOriginalToken: true },
      );
      return (res.data?.data ?? null) as PlaceSuggestion | null;
    },
    enabled: () => {
      const aid = unref(accountId);
      const sid = unref(suggestionId);
      return aid != null && aid !== 0 && !!sid;
    },
    staleTime: 60 * 1000,
  });

  const suggestion = computed<PlaceSuggestion | null>(
    () => query.data.value ?? null,
  );

  return {
    ...query,
    suggestion,
  };
}
